<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          
          <div class="text-center mb-5"><img src="img/logo.png" style="width: 80%;"></div>

          <!--div class="text-center text-muted mb-4">
            Sign up
          </div-->
          <base-alert type="success" class="mt-3" v-if="showSuccess">
            <strong>Registration successfully completed!</strong><br>
            You will receive an email once an administrator has validated your account.
          </base-alert>
          <form name="register" role="form" @submit.prevent="handleForm(!v$.$invalid)" novalidate v-if="!showSuccess">
            <div class="row">
              <div class="col-sm-6">
                <base-input
                  formClasses="input-group-alternative"
                  placeholder="Lastname"
                  v-model="v$.user.lastName.$model"
                  :valid="isValid(v$.user.lastName)"
                  required
                >
                </base-input>
              </div>
              <div class="col-sm-6">
                <base-input
                  formClasses="input-group-alternative"
                  placeholder="Firstname"
                  v-model="v$.user.firstName.$model"
                  :valid="isValid(v$.user.firstName)"
                  required
                >
                </base-input>
              </div>
            </div>

            <base-input
              formClasses="input-group-alternative"
              placeholder="Email"
              addon-left-icon="ni ni-email-83"
              v-model="v$.user.email.$model"
              :valid="isValid(v$.user.email) && !errors['email']"
              :error="errors['email']"
              focused
              required
            >
            </base-input>

            <base-input
              formClasses="input-group-alternative"
              placeholder="Password"
              type="password"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="v$.user.plainPassword.$model"
              :valid="isValid(v$.user.plainPassword) && !errors['password']"
              :error="errors['password']"
              required
            >
            </base-input>

          <div class="form-group">
            <label for="user_group">Group</label>
            <select id="user_group" 
            class="form-control" 
            v-model="v$.user.group.$model"
            :class="[{ 'is-valid': isValid(v$.user.group) },{ 'is-invalid': isValid(v$.user.group) === false }]"
            required>
              <option v-for="group in enabledGroups" :key="group.id" v-bind:value="group['@id']">{{group.name}}</option> 
            </select>
          </div>

            <div class="text-center">
              <base-button nativeType="submit" type="primary" class="my-4" :disabled="loading">Create account</base-button>
            </div>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">

        </div>
        <div class="col-6 text-right">
          <router-link to="/login" class="text-light">
            <small>Sign in</small>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

export default {
  name: "register",
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      groups: [], 
      user: {
        email: "",
        firstName: '',
        lastName: '',
        plainPassword: "",
        group: ''
      },
      loading: false,
      isSubmitted: false,
      message: "",
      showSuccess: false,
      errors: {}  
    };
  },
  validations() {
    return {
        user: {
            email: {required, email},
            firstName: {required},
            lastName: {required},
            plainPassword: {required},
            group: {required}
        } 
    } 
  },
  created() {
    this.$resources.groups.list().then(response => (this.groups = response.data));
	},
  computed: {
    enabledGroups() {
      return this.groups.filter(group => group.enabled)
    }
  },
  methods: {
    isValid(item){
        if (!this.isSubmitted){
          return null;
        } 

        return !item.$invalid;
    }, 
      handleForm(isValid) {
          this.isSubmitted = true;
          this.message = '';
          
          if (!isValid){
              return;
          } 

          this.loading = true;
          this.$resources.users.create(this.user).then(()  => {
            this.showSuccess = true; 
          }, error => {
            this.loading = false;
            if (error.response && error.response.data && error.response.data.violations) {
                error.response.data.violations.forEach(data  => {
                  this.errors[data.propertyPath] = data.message;
                });
                console.log(this.errors);
            } 
          });
          /*this.$store.dispatch(AUTH_REQUEST, this.user).then(
              () => {
                  this.$router.push('/');
              }, 
              error => {
                  this.loading = false;
                  this.message = (error.response && error.response.data && error.response.data.message);
              } 
          )*/
      }
  } 
};
</script>
<style></style>
